import { Form, Row, Col, Button } from 'react-bootstrap'
import { useState, useEffect } from 'react'
import { Request } from '@group-devs/yfp7-global-modules'
import Alert from '@group-devs/yfp7-global-modules/components/Alert'

const request = new Request(process.env.apiDomain)

function WebsiteDetails(props) {
    console.log(props)
    let contactAccount = props.contactAccount
    let personal_metadata = typeof contactAccount != "undefined" && contactAccount.contact.socialSpace ? JSON.parse(JSON.parse(contactAccount.contact.socialSpace.personal_metadata)) : {}

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [key, setKey] = useState(0);

    const [showUpdate, setShowUpdate] = useState(false);
    const [readOnly, setReadOnly] = useState(true);
    const [contactId, setContactId] = useState(null);
    const [data, setData] = useState({ 
        personal_metadata: null,
    })

    useEffect(() => {
        if(typeof contactAccount != 'undefined'){
            setData({ 
                personal_metadata: personal_metadata ? personal_metadata.url : "",
            })

            setContactId(contactAccount.contact_id)
        }
    }, [contactAccount]);

    const onClickEdit = () => {
        setShowUpdate(!showUpdate)
        setReadOnly(false)
    }

    const onClickCancel = () => {
        setShowUpdate(!showUpdate)
        setReadOnly(true)
    }

    function handleChange(evt)
    {
        const value = evt.target.value;
        setData({
          ...data,
          [evt.target.name]: value
        });
    }

    async function handleSave(e)
    {
        let res = await request.contacts.updateSocialSpaces({...data, contact_id: contactId});
        if(res.err){
            console.log('error')
            setErrorMessage('Something went wrong on saving.')
        }else{
            onSuccess('Successfully updated website details.')
            onClickCancel()
        }
    }

    const onSuccess = (message) => 
    {
        setSuccessMessage(message)
        setErrorMessage(''); // Clear error message if any
        setKey(prevKey => prevKey + 1); // Change key to force re-render
    }

    return (
        <div className="websiteDetails py-5">
            <Row>
                <Col xl={{span:10, offset:1}}>
                    <Alert key={key} successMessage={successMessage} errorMessage={errorMessage}/>
                    <p><strong>Websites</strong></p>
                    <Form>
                        <Form.Group as={Row} controlId="formPlaintextWebsite" className="mb-4">
                            <Form.Label column md="3" className="text-md-right">Blog or Website</Form.Label>
                            <Col md="7">
                                <Form.Control type="text" className="rounded-0"  name="personal_metadata" onChange={handleChange} value={data.personal_metadata} readOnly={readOnly}/>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextOther">
                            <Form.Label column md="3"></Form.Label>
                            <Col md="7">
                                {!showUpdate && <Button onClick={onClickEdit} className="px-5 py-2 mb-2 btn btn-success rounded-pill"><strong>Edit</strong></Button>}
                                {showUpdate && 
                                    <>
                                        <Button className="px-5 py-2 mr-2 mb-2 btn btn-success rounded-pill" onClick={handleSave}><strong>Save</strong></Button> 
                                        <Button onClick={onClickCancel} className="px-5 py-2 mb-2 btn btn-secondary rounded-pill"><strong>Cancel</strong></Button> 
                                    </>
                                }                        
                            </Col>
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default WebsiteDetails
